/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Western_AsiaInputs */

const bn_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পশ্চিম এশিয়া`)
};

const de_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Westasien`)
};

const el_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δυτική Ασία`)
};

const en_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Western Asia`)
};

const es_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia occidental`)
};

const fr_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asie occidentale`)
};

const hi_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पश्चिमी एशिया`)
};

const hu_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyugat-Ázsia`)
};

const id_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia Barat`)
};

const it_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia occidentale`)
};

const ja_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西アジア`)
};

const ko_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서아시아`)
};

const nl_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`West-Azië`)
};

const pl_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azja Zachodnia`)
};

const pt_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ásia Ocidental`)
};

const ru_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Западная Азия`)
};

const sv_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Västra Asien`)
};

const tr_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batı Asya`)
};

const uk_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Західна Азія`)
};

const vi_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tây Á`)
};

const zh_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西亚`)
};

const zh_hant_geo_label_western_asia = /** @type {(inputs: Geo_Label_Western_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西亞`)
};

/**
* | output |
* | --- |
* | "Western Asia" |
*
* @param {Geo_Label_Western_AsiaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_western_asia = /** @type {((inputs?: Geo_Label_Western_AsiaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Western_AsiaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_western_asia(inputs)
	if (locale === "de") return de_geo_label_western_asia(inputs)
	if (locale === "el") return el_geo_label_western_asia(inputs)
	if (locale === "en") return en_geo_label_western_asia(inputs)
	if (locale === "es") return es_geo_label_western_asia(inputs)
	if (locale === "fr") return fr_geo_label_western_asia(inputs)
	if (locale === "hi") return hi_geo_label_western_asia(inputs)
	if (locale === "hu") return hu_geo_label_western_asia(inputs)
	if (locale === "id") return id_geo_label_western_asia(inputs)
	if (locale === "it") return it_geo_label_western_asia(inputs)
	if (locale === "ja") return ja_geo_label_western_asia(inputs)
	if (locale === "ko") return ko_geo_label_western_asia(inputs)
	if (locale === "nl") return nl_geo_label_western_asia(inputs)
	if (locale === "pl") return pl_geo_label_western_asia(inputs)
	if (locale === "pt") return pt_geo_label_western_asia(inputs)
	if (locale === "ru") return ru_geo_label_western_asia(inputs)
	if (locale === "sv") return sv_geo_label_western_asia(inputs)
	if (locale === "tr") return tr_geo_label_western_asia(inputs)
	if (locale === "uk") return uk_geo_label_western_asia(inputs)
	if (locale === "vi") return vi_geo_label_western_asia(inputs)
	if (locale === "zh") return zh_geo_label_western_asia(inputs)
	return zh_hant_geo_label_western_asia(inputs)
});